import { Product } from '@vimond/services/rest-api/types';
import ProductCard from './ProductCard';

type ProductsListProps = {
  onSelectProduct: (id: number) => void;
  products: Product[];
};

export const ProductsList = ({
  onSelectProduct,
  products,
}: ProductsListProps) => {
  return (
    <div className="flex flex-wrap w-full gap-4 items-center justify-center">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onSelectProduct={onSelectProduct}
        />
      ))}
    </div>
  );
};
